import { register as universalRegister, login as universalLogin, registerV2 as universalRegisterV2, loginV2 as universalLoginV2, changePassword as universalChangePassword, loginWithIdpConnectionTokenParams as universalLoginWithIdpConnectionTokenParams, proceedToNextState as universalProceedToNextState, signOn as universalSignOn, logout as universalLogout, } from './iam-authentication-v1-authentication-authentication.universal';
export const __metadata = { PACKAGE_NAME: '@wix/identity' };
export function register(httpClient) {
    return (identity, options) => universalRegister(identity, options, 
    // @ts-ignore
    { httpClient });
}
export function login(httpClient) {
    return (identifier, options) => universalLogin(identifier, options, 
    // @ts-ignore
    { httpClient });
}
export function registerV2(httpClient) {
    return (loginId, options) => universalRegisterV2(loginId, options, 
    // @ts-ignore
    { httpClient });
}
export function loginV2(httpClient) {
    return (loginId, options) => universalLoginV2(loginId, options, 
    // @ts-ignore
    { httpClient });
}
export function changePassword(httpClient) {
    return (newPassword) => universalChangePassword(newPassword, 
    // @ts-ignore
    { httpClient });
}
export function loginWithIdpConnectionTokenParams(httpClient) {
    return (options) => universalLoginWithIdpConnectionTokenParams(options, 
    // @ts-ignore
    { httpClient });
}
export function proceedToNextState(httpClient) {
    return (options) => universalProceedToNextState(options, 
    // @ts-ignore
    { httpClient });
}
export function signOn(httpClient) {
    return (loginId, options) => universalSignOn(loginId, options, 
    // @ts-ignore
    { httpClient });
}
export function logout(httpClient) {
    return (options) => universalLogout(options, 
    // @ts-ignore
    { httpClient });
}
export { PrivacyStatus, EmailTag, PhoneTag, AddressTag, StatusName, Reason, StateStatus, StateType, TenantType, } from './iam-authentication-v1-authentication-authentication.universal';
export { onAuthenticationSuccessfulLoginEvent } from './iam-authentication-v1-authentication-authentication.universal';
//# sourceMappingURL=iam-authentication-v1-authentication-authentication.public.js.map